import { ClozeTestService } from "./../../service/cloze-test.service";
import { Component, OnInit, input, inject, signal, WritableSignal, Output, EventEmitter } from "@angular/core";
import { InputFieldComponent } from "./input-field/input-field.component";
import { FormsModule } from "@angular/forms";
import { NgClass } from "@angular/common";
import { AnswerDto } from "../../dto";

@Component({
  selector: "onset-cloze-test-exercise-input",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
  standalone: true,
  imports: [InputFieldComponent, FormsModule, NgClass],
})
export class InputComponent implements OnInit {
  // default max char count so the design doesn't break
  readonly clozeTestService = inject(ClozeTestService);
  readonly MAX_ANSWER_CHAR_COUNT = 20;

  readonly mobileMode = input(false);
  readonly nr = input(0);
  readonly text = input("");
  readonly lastWord = input("");
  readonly isLast = input(false);
  readonly answer = input({
    buchungId: 0,
    aufgabeId: 0,
    nr: 0,
    antwort: "",
  } as AnswerDto);
  readonly currentAnswer: WritableSignal<AnswerDto> = signal({
    buchungId: 0,
    aufgabeId: 0,
    nr: 0,
    antwort: "",
  });

  @Output() answerChange = new EventEmitter<AnswerDto>();

  currentValue = "";
  isFocused = false;

  ngOnInit() {
    // mobile mode use input field for navigating between characters
    this.currentAnswer.set(this.answer());
    if (!this.mobileMode()) {
      this.clozeTestService.insertSpecialCharacterToInput$$.subscribe((specialCharacter) => {
        if (this.clozeTestService.inputNumber === this.nr()) {
          this.#addCharacterToInput(specialCharacter);
        }
      });

      this.clozeTestService.removeLastCharacter$$.subscribe(() => {
        if (this.clozeTestService.inputNumber === this.nr()) {
          this.#removeCharacterFromInput();
        }
      });
    }
  }

  public onInputChange(): void {
    this.currentAnswer.set({
      ...this.currentAnswer(),
      antwort: this.currentValue,
    });
    this.answerChange.emit(this.currentAnswer());
  }

  public focusInput(): void {
    this.clozeTestService.setActiveInputNumber(this.nr());
    this.isFocused = true;
  }

  public onBlur(): void {
    this.isFocused = false;
  }

  #addCharacterToInput(character: string) {
    if (this.currentValue.length <= this.MAX_ANSWER_CHAR_COUNT) {
      this.currentValue += character;
      this.onInputChange();
    }
  }

  #removeCharacterFromInput(): void {
    this.currentValue = this.currentValue.slice(0, -1);
    this.onInputChange();
  }

  public isActiveInput(): boolean {
    return this.clozeTestService.inputNumber === this.nr();
  }
}
